<template>
  <div>
    <el-dialog
      title="选择线路"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="1000px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <section class="dialogContent">
        <qx-search-box
          class="searchBox"
          ref="searchBox"
          :searchBoxData="searchBoxData"
          @sub="sub"
          :inDialog="true"
          permpisionsQuery
        />
        <TableBox :isRadio="isRadio" ref="tableBox" />
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="choose" :loading="subLoading">确定</el-button>
      </section>
    </el-dialog>
    <template v-if="isInput">
      <el-autocomplete
        class="norderFormWidth"
        popper-class="my-autocomplete"
        v-model="resultVal.lineCodeName"
        :placeholder="'请输入线路关键词，临时线路无需填写'"
        :disabled="disabled"
        :fetch-suggestions="querySearchAsync"
        @select="(val) => { onSelect && onSelect(val); }"
      >
        <span slot="suffix" class="inputSlotText cur primary" @click="showChooseDialog">选择</span>
        <template slot-scope="{ item }">
          <div class="name">
            <span class="success-bg" style="color: #ffffff;">常</span>
            <span style="margin-left:4px;">{{ item.lineCodeName }}</span>
          </div>
          <div class="addr">线路编码：{{ item.lineCodeRule }}</div>
          <div class="addr">客户名称：{{ item.customerName }}</div>
          <div class="addr">车型：{{ item.vehicleStatusName }}/{{ item.vehicleLengthName }}</div>
          <div class="addr">
            预估：
            <span class="error">￥{{ item.estimateIncome/ 100 }}</span>
          </div>
        </template>
      </el-autocomplete>
    </template>
    <template v-else>
      <div
        class="chooseShowBox posire cur"
        :title="
        isRadio
          ? (this.resultVal.lineCodeName
              ? this.resultVal.lineCodeName +
                (this.resultVal.lineCodeRule
                  ? '/' + this.resultVal.lineCodeRule
                  : '')
              : '') || ''
          : ''
      "
        :class="{
        active: Boolean(this.resultVal.lineCodeName),
        disabled: disabled,
      }"
        @click="showChooseDialog"
      >
        {{
        isRadio
        ? (this.resultVal.lineCodeName
        ? this.resultVal.lineCodeName +
        (this.resultVal.lineCodeRule
        ? '/' + this.resultVal.lineCodeRule
        : '')
        : '') || '请选择'
        : '请选择'
        }}
        <i
          class="el-icon-arrow-down posiab downIcon"
        />
      </div>
    </template>
    <div class="tableBox" v-if="!isRadio && resultVal.length > 0">
      <el-table :data="resultVal" tooltip-effect="dark">
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        />
        <el-table-column width="55" label="操作">
          <template slot-scope="scope">
            <span class="cur blur" @click="delCheckboxSelect(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import TableBox from './tableBox';
import {
  queryIntelligentMatchCustomer,
  queryLineList,
} from 'api/operate';
export default {
  components: {
    TableBox,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isInput: {
      type: Boolean,
      default: false,
    },
    customerInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      defaultSearchData: {},
      dialogFormVisible: false,
      subLoading: false,
      text: '',
      searchBoxData: {
        provinceIdOptions: [],
        form: [
          { // 线路名称
            label: '线路名称',
            value: 'lineCodeName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 线路编码
            label: '线路编码',
            value: 'lineCodeRule',
            type: 'input',
            placeholder: '请输入线路编码',
          },
          { // 客户名称
            label: '客户名称',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
        ],
      },
      radioResult: {},
      checkboxResult: [],
      tableData: {
        title: [
          {
            prop: 'lineCodeName',
            label: '线路名称',
          },
          {
            prop: 'navigatSourceLocation',
            label: '始发地',
          },
          {
            prop: 'navigatDesLocation',
            label: '目的地',
          },
          {
            prop: 'companyName',
            label: '客户名称',
          },
        ],
      },
    };
  },
  methods: {
    show (text) {
      this.dialogFormVisible = true;
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.state = 1;
      searchBoxData.vehicleStatus = 2;
      this.$refs.tableBox.saveSearchBoxData({
        ...this.otherSearchData,
        ...searchBoxData,
      });
    },
    showChooseDialog () {
      if (this.disabled) {
        return;
      }
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.searchBox.sub();
      });
    },
    cancle () {
      this.dialogFormVisible = false;
      this.$refs.tableBox.tableData.selectResult = [];
    },
    choose () {
      if (this.isRadio) {
        this.radioResult = this.$refs.tableBox.getSelectRadioData(); // 单选
        this.$emit('cc', this.radioResult);
        this.$emit('change', this.radioResult);
      } else {
        // this.checkboxResult = [ // 多选
        //   ...this.checkboxResult,
        //   ...this.$refs.tableBox.getSelectData(),
        // ];
        this.checkboxResult = this.$refs.tableBox.getSelectData();
        this.$emit('cc', this.checkboxResult);
        this.$emit('change', this.checkboxResult);
      }
      this.dialogFormVisible = false;
      this.$refs.tableBox.tableData.selectResult = [];
    },
    // 选择输入的项
    chooseSelectItem (item) {
      this.$emit('cc', item);
      this.$emit('change', item);
    },
    delCheckboxSelect (item) {
      this.checkboxResult.splice(this.checkboxResult.indexOf(item), 1);
    },
    setValueName (items) {
      for (let item of items) {
        item.lineInfoName = item.lineCodeName
          ? item.lineCodeName +
          (item.lineCodeRule
            ? '/' + item.lineCodeRule
            : '')
          : '';
      }
    },
    querySearchAsync (queryString, cb) {
      let resInfo = [];
      if (queryString && queryString.length) {
        queryLineList({
          customerId: this.customerInfo.customerId || '',
          lineKey: queryString,
        }).then((res) => {
          if (res && res.items) {
            resInfo = res.items;
          }
          this.setValueName(resInfo);
          cb(resInfo);
        });
      } else {
        // 当没有输入的时候
        resInfo = this.defaultSearchData.items;
        this.setValueName(resInfo);
        cb(resInfo);
      }
    },
    onSelect (item) {
      if (item) {
        this.chooseSelectItem(item);
      }
    },
  },
  async mounted () {
    this.defaultSearchData = await queryIntelligentMatchCustomer({ searchType: 2 });
  },
};
</script>

<style scoped lang="scss">
.dialogContent {
  padding-bottom: 24px;
}
.searchBox {
  ::v-deep .customForm {
    margin: 0;
  }
}
::v-deep .el-radio-group {
  width: 100%;
}
.chooseShowBox {
  height: 32px;
  line-height: 32px;
  width: 240px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  padding: 0 15px;
  border-radius: 4px;
  color: #c0c4cc;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .downIcon {
    font-size: 14px;
    right: 5px;
    top: 8px;
    color: #c0c4cc;
  }
}
.active {
  color: #333;
}
.disabled {
  background-color: #f5f7fa;
  color: #c0c4cc;
}

.my-autocomplete {
  li {
    padding-bottom: 7px;
    .name {
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 1.8;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
      line-height: 1.6;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>
